import React from 'react';
import { useSelector } from 'react-redux';
import { getGroupNetOpenValue } from './utils/groupCalculation'; 

const GroupNetOpenValue = React.memo(({ positionList, symbolId }) => {
    const symbol = useSelector((state) => state.updateSymbol.symbols?.[symbolId]);
    const contractSize = symbol?.contractSize ?? 100;

    const value = getGroupNetOpenValue(positionList, contractSize);

    const formatAmount = (val) =>isNaN(val) ? "0.00" : Number(val).toLocaleString(undefined, {  minimumFractionDigits: 2,  maximumFractionDigits: 2,});

    return <span>{formatAmount(value)}</span>;
});

export default GroupNetOpenValue;
